export default __webpack_public_path__ + "static/media/1030_1032_new.7f2d73b0.jpg";